import { Code, TrendingUp, Activity } from "lucide-react"

interface CareerPath {
  name: string
  focus: string
  icon: "code" | "manufacturing" | "science"
}

interface CareerPathsCardProps {
  careerPaths: CareerPath[]
}

export function CareerPathsCard({ careerPaths }: CareerPathsCardProps) {
  const iconMap = {
    code: Code,
    manufacturing: Activity,
    science: TrendingUp,
  }

  const colorMap: Record<string, { bg: string; text: string; progress: string; border: string }> = {
    blue: {
      bg: "bg-blue-50",
      text: "text-blue-600",
      // progress: "bg-blue-500",
      border: "border-blue-100",
    },
    orange: {
      bg: "bg-orange-50",
      text: "text-orange-600",
      // progress: "bg-transparent",
      border: "border-orange-100",
    },
    teal: {
      bg: "bg-teal-50",
      text: "text-teal-600",
      // progress: "bg-teal-500",
      border: "border-teal-100",
    },
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-bold text-gray-900 text-base flex items-center gap-2">
          <svg className="w-5 h-5 text-teal-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 7h12M8 12h12m-7 5h7M3 7h1m0 5h1m0 5h1"
            />
          </svg>
          Active Career Paths
        </h3>
        {/* <button className="text-xs font-bold text-teal-500 hover:text-teal-600 transition-colors">View All</button> */}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {careerPaths.map((path) => {
          const Icon = iconMap[path.icon]
          const colors = colorMap[path.color]

          return (
            <div
              key={path.name}
              className={`border ${colors.border} rounded-lg p-3 hover:border-teal-300 transition-all bg-gray-50`}
            >
              <div className="flex items-center gap-3 mb-2">
                <div
                  className={`w-8 h-8 rounded ${colors.bg} ${colors.text} flex items-center justify-center shrink-0 border ${colors.border}`}
                >
                  <Icon className="w-4 h-4" />
                </div>
                <div className="overflow-hidden">
                  <h4 className="font-bold text-gray-900 text-xs truncate">{path.name}</h4>
                  <p className="text-[10px] text-gray-500 truncate">Focus: {path.focus}</p>
                </div>
              </div>
           
            </div>
          )
        })}
      </div>
    </div>
  )
}
